'use client';

import { HomepageHero } from '@/src/components/HomepageHero';
import { getHomepageHeroConfig, type HomepageHeroId, selectMatchingHomepageHeroId } from '@/src/lib/homepageHero';
import type { HomepageHeroSeason } from '@/src/lib/homepageHeroSeason';
import { useCurrentArea } from '@/src/lib/hooks/query/useCurrentArea';

type CurrentAreaHomepageHeroProps = {
  fallbackHeroId: HomepageHeroId;
  season?: HomepageHeroSeason | null;
  overrideHeroId?: HomepageHeroId | null;
};

export function CurrentAreaHomepageHero({ fallbackHeroId, overrideHeroId, season }: CurrentAreaHomepageHeroProps) {
  const { data: currentArea } = useCurrentArea();
  const heroId = overrideHeroId ?? selectMatchingHomepageHeroId(currentArea) ?? fallbackHeroId;

  return <HomepageHero hero={getHomepageHeroConfig(heroId)} season={season} />;
}
